$('#city').on('input change',  function(e) {
	if ($(this).val().length > 0) {
		$(this).closest('.form__row').siblings('.order-delivery__accordion').find('.accordion__item').removeClass('disable');
        $(this).css('border-color', '#dbe0e2');
        $(this).siblings('.error').remove();
	} else {
        $(this).closest('.form__row').siblings('.order-delivery__accordion').find('.accordion__item').addClass('disable');
    } 
});


$(window).on('load resize', function() {

    if ($(window).width() > 1025) {
        var orderInfo =  $('.js-order-fixed');  
        var orderWrapper = $('.order'); 

        $(window).scroll(function(){
            var scrollTop = $(document).scrollTop();
            var orderWrapperTop = orderWrapper.offset().top;
            var orderWrapperBottom = orderWrapperTop + orderWrapper.outerHeight() - $(window).height();
            
            if (scrollTop > orderWrapperTop) {  
                orderInfo.css({
                    'position':'fixed',
                    'width': '550'
                });
            } else { 
                orderInfo.css('position','absolute'); 
            }

            if (scrollTop>orderWrapperBottom) { 
                orderInfo.css('top', orderWrapperBottom - scrollTop); 
            } else { 
                orderInfo.css('top', '0'); 
            }
        });
    }
});

//добавляем ошибку к инпуту город если он не выбран

$('.order-delivery__accordion').on('click', function(e) {
    var item = $(this).find('.accordion__item');
    var wrap = $('#city').parent();

    if ($('#city').val().length <= 0 && wrap.children('.error').length <= 0) {
        wrap.append('<div class="error">Пожалуйста, заполните поле</div>');   

        $('#city').css({
            'border-color': 'red'
        })  
    }
});

// при клике на пункт меню ставим класс ignor для валидации формы

$('[data-role="trigger"]').on('click', function(e) {
    e.preventDefault();
    var $trigger = $(e.currentTarget);
    var $item = $trigger.parent();
    var $siblings = $item.siblings();

    if($item.hasClass('is-open')) {
        $siblings.find('.input').addClass('ignore');
        $siblings.find('.textarea').addClass('ignore');
    } else {
        $siblings.find('.input').removeClass('ignore');
        $siblings.find('.textarea').removeClass('ignore');
    }

   
})

